import { FC } from 'react';
import { Box, useDisclosure } from '@chakra-ui/react';

import { TransactionType } from '__generated__/GQL';
import { UploadedFileInfo } from 'components/Upload/types';

import { DetailedTransactionFragment } from '../../../../graphql/fragment/detailedTransaction.gql';
import useCreateTransactionReceiptMutation from '../../hooks/useCreateTransactionReceiptMutation';
import InvoiceSearchModal from './components/InvoiceSearchModal';
import LinkToInvoiceButton from './components/LinkToInvoiceButton';
import Upload from './components/Upload';

const LinkInvoiceOrUpload: FC<{
  transaction: DetailedTransactionFragment;
}> = ({ transaction }) => {
  const {
    isOpen: isSearchModalOpen,
    onClose: onCloseSearchModal,
    onOpen: onOpenSearchModal,
  } = useDisclosure();

  const [createTransactionReceipt] = useCreateTransactionReceiptMutation({
    transactionId: transaction.transactionId,
    transactionTotal: transaction.value,
    transactionType: transaction.type,
  });

  const handleCreateReceipt = async ({
    fileName,
    ...file
  }: UploadedFileInfo) => {
    await createTransactionReceipt(file);
  };

  return (
    <Box>
      {transaction.type === TransactionType.Payin ? (
        <LinkToInvoiceButton onClick={onOpenSearchModal} />
      ) : null}

      <Upload createReceipt={handleCreateReceipt} />

      <InvoiceSearchModal
        isOpen={isSearchModalOpen}
        onClose={onCloseSearchModal}
        transaction={transaction}
      />
    </Box>
  );
};

export default LinkInvoiceOrUpload;
